// extracted by mini-css-extract-plugin
export default {"start_btn":"SetMyParkingLocationButton_start_btn__wVKIf","button_text":"SetMyParkingLocationButton_button_text__9ttpK","default_btn":"SetMyParkingLocationButton_default_btn__1XYif"};